<ion-card class="ion-no-margin ion-margin-bottom">
  <ion-card-content>

    <!-- Title -->
    <ion-row>
      <ion-col size="12" class="ion-no-padding">
        <ion-label class="primary-color font-family-bold contact-title">
          {{ contactDetails()?.contactType }}
        </ion-label>
      </ion-col>
    </ion-row>

    <!-- Contact Row: Inline Phone & Email -->
    <ion-row class="ion-margin-top">
      <ion-col size="12" class="ion-no-padding">

        @if (isMobileApp()) {
        <!-- Mobile Implementation -->
        @if (contactDetails()?.contactPhone) {
        <span class="contact-accent-link">
          <a (click)="callHolman(contactDetails()?.contactPhone)">{{ contactDetails()?.contactPhone }}</a>
        </span>
        }
        @if (contactDetails()?.contactEmail) {
        <span class="contact-accent-link">
          <a (click)="openMail(contactDetails()?.contactEmail)">{{ contactDetails()?.contactEmail }}</a>
        </span>
        }
        } @else {
        <!-- Web Implementation -->
        @if (contactDetails()?.contactPhone) {
        <span class="contact-accent-link">
          <a [href]="'tel:' + contactDetails()?.contactPhone">{{ contactDetails()?.contactPhone }}</a>
        </span>
        }
        @if (contactDetails()?.contactEmail) {
        <span class="contact-accent-link">
          <a [href]="'mailto:' + contactDetails()?.contactEmail">{{ contactDetails()?.contactEmail }}</a>
        </span>
        }
        }

      </ion-col>
    </ion-row>

    <!-- Description -->
    <ion-row>
      <ion-col size="12" class="ion-no-padding">
        <p class="contact-description">
          {{ contactDetails()?.description }}
        </p>
      </ion-col>
    </ion-row>

  </ion-card-content>
</ion-card>